<template>
    <div>
        <template v-if="value.side == EMPLOYMENT_FIELD_SIDES.DOCUMENT.value">
            <img v-bind="{ src }" style="max-width: 100%" />
        </template>
        <template v-else>
            <template v-if="false"></template>
            <template v-else-if="mode == 'done'">
                <img v-bind="{ src }" style="max-width: 100%" />
            </template>
            <template v-else-if="mode == 'sign'">
                <node-edit v-bind="{ value, width: 480 }" v-on="{ sync, emit }">
                    <template #activator="{ attrs, on }">
                        <v-card v-bind="attrs" v-on="on" flat tile width="100%" height="100%" color="transparent" class="d-flex justify-center align-center">
                            <v-img v-bind="{ src }" color="primary">
                                <template v-if="!src">
                                    <span style="opacity: 0.5; word-break: auto-phrase">
                                        {{ value.term }}
                                    </span>
                                </template>
                            </v-img>
                        </v-card>
                    </template>
                    <node-sign-form v-model="form.img" v-on="{ sync }" />
                </node-edit>
            </template>
            <template v-else>
                <span style="opacity: 0.5; word-break: auto-phrase">
                    {{ value.term }}
                </span>
            </template>
        </template>
    </div>
</template>

<script>
import { EMPLOYMENT_FIELD_SIDES, initEmploymentField } from "@/assets/variables";

import NodeEdit from "./node-edit.vue";
import NodeSignForm from "./node-sign-form.vue";

export default {
    components: {
        NodeEdit,
        NodeSignForm,
    },
    props: {
        value: { type: Object, default: initEmploymentField },

        /** @type {import('vue').PropType<'form'|'sign'|'view'|'done''>} */
        mode: { type: String, default: "form" },
    },
    data: () => ({
        form: initEmploymentField(),
        EMPLOYMENT_FIELD_SIDES,
    }),
    computed: {
        src() {
            if (this.value?.img instanceof File) return URL.createObjectURL(this.value?.img);
            else return this.value?.img?.src;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentField(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .v-input--selection-controls__input {
    margin: 0 !important;
}
</style>
